<template>
  <header class="my-5">
    <a href="https://www.amnistie.ca">
      <v-img
        src="@/assets/img/logo-black.png"
        class="header-logo"
        height="80"
        width="76"
      ></v-img>
    </a>
  </header>
</template>

<script>
export default {};
</script>

<style scoped lang="scss">
a {
  text-decoration: none;
}
.header-logo {
  position: absolute;
  top: 20px;
}
</style>